import { render, staticRenderFns } from "./arrayTable.vue?vue&type=template&id=6e04a2e3"
import script from "./arrayTable.vue?vue&type=script&lang=js"
export * from "./arrayTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports